import PropTypes from 'prop-types';
import { useEffect } from 'react';

KTScrollTop.propTypes = {
  additionalClassName: PropTypes.string,
};

const KTScrolltop = require('assets/plugins/ktscrolltop');

function KTScrollTop({ additionalClassName = '' }) {
  // MARK: --- Hooks ---
  useEffect(() => {
    if (typeof KTScrolltop !== undefined) {
      new KTScrolltop('kt_scrolltop', {
        offset: 100,
        speed: 20,
      });
    }
  }, []);

  return (
    <div id="kt_scrolltop" className={`scrolltop ${additionalClassName}`}>
      <i className="fa-solid fa-caret-up" />
    </div>
  );
}

export default KTScrollTop;
